/**
 * 2010-2015 Lexus RX Conversion Kit only:
 * There is no 2010-2012 + Knob variant. Hide "Knob" when Vehicle Year is 2010-2012
 * so the UI never shows a crossed-out / Unavailable state for that combo.
 */
(function () {
  var HANDLE = '2010-2015-lexus-rx-apple-carplay-conversion-kit-premium';
  var YEAR_HIDE_KNOB = '2010-2012';
  var INTERFACE_HIDE = 'Knob';
  var INTERFACE_FALLBACK = 'Mouse/Joystick';

  function pathMatches() {
    try {
      return window.location.pathname.indexOf('/products/' + HANDLE) !== -1;
    } catch (e) {
      return false;
    }
  }

  function roots() {
    return Array.prototype.slice.call(
      document.querySelectorAll(
        '[data-hmc-rx-2010-2015-hide-knob], form.product-form, [data-section-type="product"]'
      )
    );
  }

  function optionControls(root, position) {
    return Array.prototype.slice.call(
      root.querySelectorAll(
        '.product-form__single-selector[data-option-position="' + position + '"]'
      )
    );
  }

  function selectedValue(controls) {
    if (!controls.length) return '';
    var el = controls[0];
    if (el.tagName === 'SELECT') return el.value || '';
    var checked = controls.filter(function (c) {
      return c.checked;
    })[0];
    return checked ? checked.value : '';
  }

  function setHidden(node, hidden) {
    if (!node) return;
    node.classList.toggle('hmc-option-value--hidden', hidden);
    node.hidden = !!hidden;
    if (hidden) node.setAttribute('aria-hidden', 'true');
    else node.removeAttribute('aria-hidden');
  }

  function hideKnobValue(root, hide) {
    // Block / color / variant swatches
    Array.prototype.slice
      .call(root.querySelectorAll('.block-swatch, .color-swatch, .variant-swatch'))
      .forEach(function (swatch) {
        var input = swatch.querySelector('.product-form__single-selector');
        if (!input) return;
        if (String(input.value) !== INTERFACE_HIDE) return;
        if (String(input.getAttribute('data-option-position')) !== '2') return;
        setHidden(swatch, hide);
        if (hide && input.checked) {
          input.checked = false;
        }
      });

    // Native <select> for Vehicle Interface (option position 2)
    optionControls(root, 2).forEach(function (control) {
      if (control.tagName !== 'SELECT') return;
      Array.prototype.slice.call(control.options).forEach(function (opt) {
        if (String(opt.value) !== INTERFACE_HIDE) return;
        opt.hidden = !!hide;
        opt.disabled = !!hide;
        if (hide && control.value === INTERFACE_HIDE) {
          control.value = INTERFACE_FALLBACK;
        }
      });
    });
  }

  function selectFallbackInterface(root) {
    var radios = optionControls(root, 2).filter(function (c) {
      return c.tagName !== 'SELECT';
    });
    var fallback = radios.filter(function (c) {
      return String(c.value) === INTERFACE_FALLBACK && !c.closest('.hmc-option-value--hidden');
    })[0];
    if (!fallback) {
      fallback = radios.filter(function (c) {
        return !c.closest('.hmc-option-value--hidden');
      })[0];
    }
    if (fallback && !fallback.checked) {
      fallback.checked = true;
      fallback.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    var select = optionControls(root, 2).filter(function (c) {
      return c.tagName === 'SELECT';
    })[0];
    if (select && select.value === INTERFACE_HIDE) {
      select.value = INTERFACE_FALLBACK;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function syncRoot(root) {
    if (!root || !root.querySelector) return;
    var year = selectedValue(optionControls(root, 1));
    var hide = year === YEAR_HIDE_KNOB;
    var iface = selectedValue(optionControls(root, 2));
    hideKnobValue(root, hide);
    if (hide && iface === INTERFACE_HIDE) {
      selectFallbackInterface(root);
    }
  }

  function syncAll() {
    if (!pathMatches() && !document.querySelector('[data-hmc-rx-2010-2015-hide-knob]')) return;
    roots().forEach(syncRoot);
  }

  function onChange(event) {
    var t = event.target;
    if (!t || !t.classList || !t.classList.contains('product-form__single-selector')) return;
    var root =
      t.closest('[data-hmc-rx-2010-2015-hide-knob]') ||
      t.closest('form.product-form') ||
      t.closest('[data-section-type="product"]');
    if (!root) return;
    if (!pathMatches() && !root.hasAttribute('data-hmc-rx-2010-2015-hide-knob')) return;
    // Only react to year changes for hide, but always re-sync safely
    syncRoot(root);
  }

  function boot() {
    syncAll();
    document.addEventListener('change', onChange, true);
    document.addEventListener('variant:changed', syncAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
